export default "__VITE_ASSET__aa3270eb__"